// client/src/components/EditAdForm.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Form, Button, Image } from 'react-bootstrap';
import { useParams, Navigate } from 'react-router-dom';

const EditAdForm = () => {
  const { id } = useParams();
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [price, setPrice] = useState('');
  const [location, setLocation] = useState('');
  const [existingImage, setExistingImage] = useState(''); // To show current image
  const [newImage, setNewImage] = useState(null); // To hold new file upload
  const [redirect, setRedirect] = useState(false);

  useEffect(() => {
    const fetchAd = async () => {
      const response = await axios.get(`/api/ads/${id}`);
      const ad = response.data;
      setTitle(ad.title);
      setContent(ad.content);
      setPrice(ad.price);
      setLocation(ad.location);
      setExistingImage(ad.image); // Store the string filename
    };
    fetchAd();
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('title', title);
    formData.append('content', content);
    formData.append('price', price);
    formData.append('location', location);
    if (newImage) formData.append('image', newImage); // Only append if a NEW file was selected

    try {
      const token = localStorage.getItem('token');
      await axios.put(`/api/ads/${id}`, formData, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });
      alert('Ad updated successfully!');
      setRedirect(true);
    } catch (error) {
      console.error(error);
      alert('Failed to update ad');
    }
  };

  if (redirect) {
    return <Navigate to="/" />;
  }

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group controlId="formTitle" className="mb-3">
        <Form.Label>Title</Form.Label>
        <Form.Control type="text" value={title} onChange={(e) => setTitle(e.target.value)} required />
      </Form.Group>
      <Form.Group controlId="formContent" className="mb-3">
        <Form.Label>Content</Form.Label>
        <Form.Control as="textarea" value={content} onChange={(e) => setContent(e.target.value)} required />
      </Form.Group>
      <Form.Group controlId="formPrice" className="mb-3">
        <Form.Label>Price</Form.Label>
        <Form.Control type="number" value={price} onChange={(e) => setPrice(e.target.value)} required />
      </Form.Group>
      <Form.Group controlId="formLocation" className="mb-3">
        <Form.Label>Location</Form.Label>
        <Form.Control type="text" value={location} onChange={(e) => setLocation(e.target.value)} required />
      </Form.Group>

      {/* Show existing image if it exists */}
      {existingImage && (
        <div className="mb-3">
          <Form.Label>Current Image</Form.Label>
          <div>
            <Image src={`/uploads/${existingImage}`} alt="Current ad" thumbnail style={{ height: '100px' }} />
          </div>
        </div>
      )}

      <Form.Group controlId="formImage" className="mb-3">
        <Form.Label>Change Image (Optional)</Form.Label>
        <Form.Control type="file" onChange={(e) => setNewImage(e.target.files[0])} accept="image/*" />
      </Form.Group>

      <Button variant="primary" type="submit">Update Ad</Button>
    </Form>
  );
};

export default EditAdForm;